import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { phoneUserLowerHand } from 'features/sip/actions';

export function* lowerPhoneUserHandSaga(action: ReturnType<typeof phoneUserLowerHand>) {
  yield call(SignalingSocket.send, {
    event: 'phoneUserLowerHand',
    data: { id: action.payload },
  });
}
